const withWorkingDays = workingDays => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    workingDays,
});

export default withWorkingDays;
